import type { FC } from 'react';
import { PaymentStructureGrid, useGridData } from '../PaymentStructureGrid';
import { useGridActions } from '../contexts';

export const FinanceStructuresGrid: FC = () => {
    const { terms, downPayments, slots } = useGridData();
    const { setTerms, setDownPayments } = useGridActions();
    const financeSlots = slots.filter((s) => s.dealType === 'finance');

    return (
        <PaymentStructureGrid
            title="Finance Structures"
            terms={terms}
            downPayments={downPayments}
            slots={financeSlots}
            dealType="finance"
            testIdPrefix="finance-structures-grid"
            onTermsCommit={setTerms}
            onDownPaymentsCommit={setDownPayments}
        />
    );
};
